module.exports = __webpack_public_path__ + "img/person-multiple.6e317349.svg";